<template>
    <div>
        <DialogoMenu ref="dialMenu"></DialogoMenu>
        <DialogoCredencial ref="dialCred" :titulo="titulo" tipo="credencial"></DialogoCredencial>
        <v-bottom-navigation v-model="value" :input-value="isActive" app height="50" background-color="primary"
            :value="value" v-if="$vuetify.breakpoint.smAndDown">


            <v-btn :to="items[0].route">
                <span v-if="$vuetify.breakpoint.mdAndDown" class="white--text">{{ items[0].title }}</span>
                <v-icon class="custom-icon" color="white">{{ items[0].icon }}</v-icon>
            </v-btn>

            <!--             <v-btn :to="items[5].route">
                <span v-if="$vuetify.breakpoint.mdAndDown" class="white--text">{{ items[5].title }}</span>
                <v-icon color="white">{{ items[5].icon }}</v-icon>
            </v-btn> -->

            <v-btn :to="items[2].route">
                <span v-if="$vuetify.breakpoint.mdAndDown" class="white--text">{{ items[2].title }}</span>
                <v-icon class="custom-icon" color="white">{{ items[2].icon }}</v-icon>
            </v-btn>
            <!--             <v-btn :to="items[3].route[user.esjubilado]">
                <span v-if="$vuetify.breakpoint.mdAndDown" class="white--text">{{ items[3].title[user.esjubilado]
                    }}</span>
                <v-icon class="custom-icon" color="white">{{ items[3].icon }}</v-icon>
            </v-btn> -->
            <v-btn @click="desplegarCredencial">
                <span v-if="$vuetify.breakpoint.mdAndDown" class="white--text">{{ items[3].title
                    }}</span>
                <v-icon class="custom-icon" color="white">{{ items[3].icon }}</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </div>
</template>

<script>

import DialogoMenu from '@/components/dialogos/DialogoMenu.vue';
import DialogoCredencial from '@/components/dialogos/DialogoCredencial.vue';
import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        DialogoMenu,
        DialogoCredencial
    },
    data() {
        return {
            fab: false,
            value: null,
            value2: 1,
            isActive: true,
            titulo: '',
            items: [
                { title: 'Mi perfil', icon: 'mdi-account-outline', route: '/dashboard' },
                { title: 'Más', icon: 'mdi-file-document-multiple-outline', route: '/Tramites' },
                { title: 'Mis turnos', icon: 'mdi-calendar-clock', route: '/Turnos' },
                { title: 'Mi credencial', icon: 'mdi-card-account-details-outline', route: ['/Boletas', '/Haberes'] },
                /* { title: ['Mis aportes', 'Mis haberes'], icon: 'mdi-printer-outline', route: ['/Boletas', '/Haberes'] }, */
                /*              { title: 'Mis aportes', icon: 'mdi-receipt-text-clock-outline', route: '/Boletas' }, */
                { title: 'Opción de nivel', icon: 'mdi-account-star-outline', route: '/OpcionDeNivel' },
                { title: 'Mis contactos', icon: 'mdi-card-account-mail-outline', route: '/listarContactos' },
            ],
            subItems: [
                { title: 'Trámites realizados', icon: 'mdi-format-list-text', route: '/Tramites' },
                { title: 'Opción de nivel', icon: 'mdi-account-star-outline', route: '/OpcionDeNivel' },
                { title: 'Medios de pago', icon: 'mdi-account-cash-outline', route: '/MediosDePago' },
            ],
        }
    },
    methods: {
        desplegarDialogo() {
            this.$refs.dialMenu.abrirDialogo()
        },

        desplegarCredencial() {
            this.titulo = 'Credencial virtual'
            this.$refs.dialCred.abrirDialogo()
        }
    },
    computed: {
        ...mapGetters('auth', ['user', 'isAuthenticated', 'emailAuth'])
    },
}

</script>

<style></style>